import { useCallback, useState } from 'react'
import {
  type AddPhotoOutcome,
  usePhotoUpload,
} from '../context/PhotoUploadProvider'

/**
 * Order-scoped facade over the photo upload queue: downscale → durable
 * enqueue → immediate drain when online (see PhotoUploadProvider/ADR-0006).
 * Resolves 'uploaded' when the photo landed on the server right away,
 * 'queued' when it will sync later.
 */
export const useOrderPhotoUpload = (orderId: number) => {
  const { addPhoto: enqueue } = usePhotoUpload()
  const [uploading, setUploading] = useState(false)

  const addPhoto = useCallback(
    async (
      source: Blob,
      takenAtIso?: string | null,
    ): Promise<AddPhotoOutcome> => {
      setUploading(true)
      try {
        return await enqueue(orderId, source, takenAtIso)
      } finally {
        setUploading(false)
      }
    },
    [orderId, enqueue],
  )

  return { addPhoto, uploading }
}
